<template>
    <div class="container-fluid">
        <b-card no-body class="bg-light text-dark">
            <b-card-body>
                <h1>{{ $t('welcome') }}</h1>
                <p>{{ $t('welcomeText') }}</p>
            </b-card-body>
        </b-card>
        <dash-board-alerts />
    </div>
</template>
<script>
    import dashBoardAlerts from './DashboardAlerts.vue';
    export default {
        components: {
            'dash-board-alerts': dashBoardAlerts
        }
    };
</script>
